export const styles = {
  container: 'flex-1 flex flex-col px-4 py-6 space-y-4',

  // Header com informações de registros
  headerContainer: 'bg-white rounded-xl border border-gray-200 shadow-sm p-4',
  headerTitle: 'text-lg font-bold text-gray-900 mb-2',
  headerInfo:
    'flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2',
  recordsInfo: 'text-sm text-gray-600',
  pageInfo: 'text-sm text-gray-500',

  // Filtros
  filtersContainer: 'flex justify-between items-center mb-6',
  filterButton:
    'flex items-center bg-white border border-gray-300 text-gray-700 rounded-lg px-4 py-2.5 text-sm font-medium hover:bg-gray-50 hover:border-gray-400 transition-all duration-150 shadow-sm',

  // Cards para mobile (padrão)
  cardsContainer: 'space-y-3',
  card: 'bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200 overflow-hidden',
  cardHeader:
    'bg-gradient-to-r from-blue-50 to-indigo-50 px-4 py-3 border-b border-gray-100',
  cardDate: 'text-sm font-semibold text-gray-900',
  cardTime: 'text-xs text-gray-500 mt-1',
  cardBody: 'p-4',
  cardRow: 'flex justify-between items-center py-2',
  cardLabel: 'text-sm font-medium text-gray-600',
  cardValue: 'text-sm font-semibold text-gray-900',
  cardStatus:
    'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium',
  cardStatusClosed: 'bg-green-100 text-green-800',
  cardStatusOpen: 'bg-yellow-100 text-yellow-800',
  cardStatusCancelled: 'bg-red-100 text-red-800',
  cardStatusAll: 'bg-purple-100 text-purple-800',
  cardAmount: 'text-lg font-bold text-green-600',
  cardActions: 'flex justify-end pt-3 border-t border-gray-100',
  cardActionButton:
    'flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-300',

  // Tabela para desktop (hidden em mobile)
  tableContainer:
    'hidden lg:block bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm',
  table: 'w-full',
  tableHeader: 'bg-gray-50',
  headerRow: '',
  headerCell:
    'px-4 py-3 text-sm font-semibold text-gray-700 border-b border-gray-200 uppercase tracking-wide text-left',
  tableBody: '',
  tableRow:
    'hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100 last:border-b-0',
  cell: 'px-4 py-3 text-sm text-gray-900',

  // Status badges
  statusBadge:
    'inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium',
  statusClosed: 'bg-green-100 text-green-800',
  statusOpen: 'bg-yellow-100 text-yellow-800',
  statusCancelled: 'bg-red-100 text-red-800',
  statusInProgress: 'bg-blue-100 text-blue-800',
  statusAll: 'bg-purple-100 text-purple-800',

  // Paginação melhorada
  paginationContainer:
    'bg-white rounded-xl border border-gray-200 shadow-sm p-4',
  paginationInfo: 'text-sm text-gray-600 mb-3 text-center',
  paginationControls: 'flex items-center justify-center space-x-2 mb-4',
  paginationButton:
    'px-3 py-2 text-sm font-medium rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:border-gray-400 transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed',
  paginationButtonActive:
    'px-3 py-2 text-sm font-medium rounded-lg bg-blue-600 text-white border border-blue-600',
  paginationButtonIcon: 'w-4 h-4',

  // Botão carregar mais
  loadMoreContainer: 'flex justify-center',
  loadMoreButton:
    'flex items-center justify-center bg-blue-600 text-white px-6 py-3 rounded-lg text-sm font-medium hover:bg-blue-700 transition-all duration-150 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed disabled:bg-gray-400',

  // Estilos para estado vazio
  emptyState:
    'flex flex-col items-center justify-center py-8 px-6 text-center bg-white rounded-xl border border-gray-200 shadow-sm',
  emptyStateIcon: 'mb-4',
  emptyStateTitle: 'text-lg font-semibold text-gray-700 mb-2',
  emptyStateMessage: 'text-gray-500 mb-6 max-w-sm leading-relaxed text-sm',
  emptyStateActions: 'flex flex-col gap-2 w-full max-w-xs',
  emptyStateButton:
    'flex items-center justify-center bg-blue-600 text-white px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-blue-700 transition-all duration-150 shadow-sm hover:shadow-md',
  emptyStateButtonSecondary:
    'flex items-center justify-center bg-gray-100 text-gray-700 px-4 py-2.5 rounded-lg text-sm font-medium hover:bg-gray-200 transition-all duration-150 shadow-sm hover:shadow-md',

  // Botão de voltar
  actionsContainer: 'mt-6',
  actionButton:
    'w-full h-[55px] bg-black text-white rounded-lg text-center hover:bg-gray-900 transition-all duration-150 text-sm font-semibold shadow-lg hover:shadow-xl text-xl font-semibold',
} as const

export const texts = {
  title: 'Cierres anteriores',
  filter: 'Filtrar',
  sort: 'Classificar',
  date: 'Fecha',
  status: 'Status',
  amount: 'Monto',
  time: 'Hora',
  actions: 'Acciones',
  goBack: 'Regresar',

  // Informações de registros
  totalRecords: 'Registros totales',
  showingRecords: 'Mostrando',
  ofRecords: 'de',
  page: 'Página',
  ofPages: 'de',

  // Status
  statusClosed: 'Cerrada',
  statusOpen: 'Abierta',
  statusCancelled: 'Cancelada',
  statusInProgress: 'En Progreso',
  statusAll: 'Todos los estados',

  // Textos para estado vazio
  emptyStateTitle: 'No hay cierres anteriores',
  emptyStateMessage:
    'No se encontraron cierres anteriores con los filtros aplicados. Intenta ajustar los filtros o recargar la página.',
  emptyStateFilterButton: 'Ajustar filtros',
  emptyStateRefreshButton: 'Recargar',

  // Paginação
  previousPage: 'Anterior',
  nextPage: 'Siguiente',
  firstPage: 'Primera',
  lastPage: 'Última',
  loadMore: 'Cargar más registros',
  noMoreRecords: 'No hay más registros',

  journey: {
    cardTime: 'Hora de cierre: ',
  },
  items: 'Ítems',
} as const
